// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var composeKleisli = /* #__PURE__ */ Control_Bind.composeKleisli(Effect.bindEffect);
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder);
var discard1 = /* #__PURE__ */ discard(Specular_Dom_Builder.bindBuilder);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var subscribeEvent_ = /* #__PURE__ */ Specular_FRP_Base.subscribeEvent_(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var monadFRP = /* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var holdDyn = /* #__PURE__ */ Specular_FRP_Base.holdDyn(monadFRP);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var $$void = /* #__PURE__ */ Data_Functor["void"](Specular_FRP_Base.functorEvent);
var append = /* #__PURE__ */ Data_Semigroup.append(/* #__PURE__ */ Foreign_Object.semigroupObject(Data_Semigroup.semigroupString));
var attr = /* #__PURE__ */ Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Foreign_Object.monoidObject(Data_Semigroup.semigroupString));
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var subscribeDyn_ = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn_(monadFRP);
var TextInput = function (x) {
    return x;
};
var Checkbox = /* #__PURE__ */ (function () {
    function Checkbox() {

    };
    Checkbox.value = new Checkbox();
    return Checkbox;
})();
var Radio = /* #__PURE__ */ (function () {
    function Radio() {

    };
    Radio.value = new Radio();
    return Radio;
})();
var unsafeEventKey = function (event) {
    return pure(event.key);
};
var textInputValue = function (v) {
    return v.value;
};
var domEventWithSample = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var newEvent = Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0());
    var discard2 = discard(Bind1);
    var onDomEvent = Specular_Dom_Builder_Class.onDomEvent(dictMonadFRP);
    var pure3 = Control_Applicative.pure(Monad0.Applicative0());
    return function (sample) {
        return function (eventType) {
            return function (node) {
                return bind1(newEvent)(function (v) {
                    return discard2(onDomEvent(eventType)(node)(composeKleisli(sample)(v.fire)))(function () {
                        return pure3(v.event);
                    });
                });
            };
        };
    };
};
var domEventWithSample1 = /* #__PURE__ */ domEventWithSample(monadFRP);
var textInput = function (dictMonadWidget) {
    var liftWidget = Specular_Dom_Widget.liftWidget(dictMonadWidget.MonadDomBuilder0());
    return function (config) {
        return liftWidget(bind(Specular_Dom_Element["el$prime"]("input")([ Specular_Dom_Element.attrsD(config.attributes) ])(pure1(Data_Unit.unit)))(function (v) {
            return discard1(liftEffect(Specular_Dom_Browser.setTextInputValue(v.value0)(config.initialValue)))(function () {
                return discard1(subscribeEvent_(Specular_Dom_Browser.setTextInputValue(v.value0))(config.setValue))(function () {
                    return bind(domEventWithSample1(function (v1) {
                        return Specular_Dom_Browser.getTextInputValue(v.value0);
                    })("input")(v.value0))(function (domChanged) {
                        return bind(holdDyn(config.initialValue)(Specular_FRP_Base.leftmost([ domChanged, config.setValue ])))(function (value) {
                            return pure1({
                                element: v.value0,
                                value: value,
                                setValue: config.setValue
                            });
                        });
                    });
                });
            });
        }));
    };
};
var textInputOnInput = function (dictMonadWidget) {
    var map1 = Data_Functor.map((((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0());
    var textInput1 = textInput(dictMonadWidget);
    return function (initial) {
        return function (attrs) {
            return map1(textInputValue)(textInput1({
                initialValue: initial,
                attributes: pure2(attrs),
                setValue: Specular_FRP_Base.never
            }));
        };
    };
};
var textInputValueEventOnEnter = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var bind1 = Control_Bind.bind(Monad0.Bind1());
    var domEventWithSample2 = domEventWithSample(dictMonadFRP);
    var pure3 = Control_Applicative.pure(Monad0.Applicative0());
    return function (v) {
        return bind1(domEventWithSample2(unsafeEventKey)("keypress")(v.element))(function (keypress) {
            var enter = $$void(Specular_FRP_Base.filterEvent(function (v1) {
                return v1 === "Enter";
            })(keypress));
            return pure3(Specular_FRP_Base.tagDyn(v.value)(enter));
        });
    };
};
var textInputValueOnChange = function (dictMonadFRP) {
    var bind1 = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
    var liftEffect1 = Effect_Class.liftEffect(dictMonadFRP.MonadEffect0());
    var domEventWithSample2 = domEventWithSample(dictMonadFRP);
    var holdDyn1 = Specular_FRP_Base.holdDyn(dictMonadFRP);
    return function (v) {
        return bind1(liftEffect1(Specular_Dom_Browser.getTextInputValue(v.element)))(function (initial) {
            return bind1(domEventWithSample2(function (v1) {
                return Specular_Dom_Browser.getTextInputValue(v.element);
            })("change")(v.element))(function (changed) {
                return holdDyn1(initial)(Specular_FRP_Base.leftmost([ v.setValue, changed ]));
            });
        });
    };
};
var textInputOnChange = function (dictMonadWidget) {
    var MonadCleanup1 = (dictMonadWidget.MonadReplace2()).MonadCleanup1();
    var bind1 = Control_Bind.bind((MonadCleanup1.Monad0()).Bind1());
    var textInput1 = textInput(dictMonadWidget);
    var textInputValueOnChange1 = textInputValueOnChange(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())(MonadCleanup1));
    return function (initial) {
        return function (attrs) {
            return bind1(textInput1({
                initialValue: initial,
                attributes: pure2(attrs),
                setValue: Specular_FRP_Base.never
            }))(function (input) {
                return textInputValueOnChange1(input);
            });
        };
    };
};
var textareaOnChange = function (dictMonadWidget) {
    var liftWidget = Specular_Dom_Widget.liftWidget(dictMonadWidget.MonadDomBuilder0());
    return function (initial) {
        return function (a) {
            return liftWidget(bind(Specular_Dom_Element["el$prime"]("textarea")([ Specular_Dom_Element.attrs(a) ])(Specular_Dom_Element.text(initial)))(function (v) {
                return bind(domEventWithSample1(function (v1) {
                    return Specular_Dom_Browser.getTextInputValue(v.value0);
                })("change")(v.value0))(function (changed) {
                    return holdDyn(initial)(changed);
                });
            }));
        };
    };
};
var checkbox = function (dictMonadWidget) {
    var liftWidget = Specular_Dom_Widget.liftWidget(dictMonadWidget.MonadDomBuilder0());
    return function (initial) {
        return function (a) {
            return liftWidget((function () {
                var attrs$prime = append(a)(append(attr("type")("checkbox"))((function () {
                    if (initial) {
                        return attr("checked")("checked");
                    };
                    return mempty;
                })()));
                return bind(Specular_Dom_Element["el$prime"]("input")([ Specular_Dom_Element.attrs(attrs$prime) ])(pure1(Data_Unit.unit)))(function (v) {
                    return bind(domEventWithSample1(function (v1) {
                        return Specular_Dom_Browser.getCheckboxChecked(v.value0);
                    })("change")(v.value0))(function (changed) {
                        return holdDyn(initial)(changed);
                    });
                });
            })());
        };
    };
};
var booleanInputTypeToAttributeValue = function (v) {
    if (v instanceof Checkbox) {
        return "checkbox";
    };
    if (v instanceof Radio) {
        return "radio";
    };
    throw new Error("Failed pattern match at Specular.DeprecatedDontUse.Input (line 70, column 3 - line 72, column 21): " + [ v.constructor.name ]);
};
var booleanInputView = function (dictMonadWidget) {
    var liftWidget = Specular_Dom_Widget.liftWidget(dictMonadWidget.MonadDomBuilder0());
    return function (type_) {
        return function (dchecked) {
            return function (dattrs) {
                return liftWidget((function () {
                    var dattrs$prime = map(function (attrs) {
                        return append(attrs)(attr("type")(booleanInputTypeToAttributeValue(type_)));
                    })(dattrs);
                    return bind(Specular_Dom_Element["el$prime"]("input")([ Specular_Dom_Element.attrsD(dattrs$prime) ])(pure1(Data_Unit.unit)))(function (v) {
                        return discard1(subscribeDyn_(Specular_Dom_Browser.setCheckboxChecked(v.value0))(dchecked))(function () {
                            return domEventWithSample1(function (v1) {
                                return Specular_Dom_Browser.getCheckboxChecked(v.value0);
                            })("change")(v.value0);
                        });
                    });
                })());
            };
        };
    };
};
var checkboxView = function (dictMonadWidget) {
    return booleanInputView(dictMonadWidget)(Checkbox.value);
};
export {
    textInputOnChange,
    textInputOnInput,
    textareaOnChange,
    textInput,
    textInputValue,
    textInputValueOnChange,
    textInputValueEventOnEnter,
    checkbox,
    checkboxView,
    Checkbox,
    Radio,
    booleanInputView
};
